export const HOME = {
  emergentLink: "emergent-link",
};

export const AUTH = {
  loginForm: "login-form",
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  registerForm: "register-form",
  registerName: "register-name",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerSubmit: "register-submit",
  logoutBtn: "logout-btn",
};

export const SIDEBAR = {
  nav: "sidebar-nav",
  dashboard: "nav-dashboard",
  leads: "nav-leads",
  customers: "nav-customers",
  quotations: "nav-quotations",
  bookings: "nav-bookings",
  itineraries: "nav-itineraries",
  visa: "nav-visa",
  payments: "nav-payments",
  whatsapp: "nav-whatsapp",
  reports: "nav-reports",
  users: "nav-users",
  accounts: "nav-accounts",
};

export const DASHBOARD = {
  container: "dashboard-container",
  statsGrid: "dashboard-stats-grid",
  leadsCard: "stats-leads-card",
  customersCard: "stats-customers-card",
  revenueCard: "stats-revenue-card",
  bookingsCard: "stats-bookings-card",
};

export const LEADS = {
  container: "leads-container",
  table: "leads-table",
  addBtn: "add-lead-btn",
  form: "lead-form",
  nameInput: "lead-name-input",
  phoneInput: "lead-phone-input",
  submitBtn: "lead-submit-btn",
};

export const CUSTOMERS = {
  container: "customers-container",
  table: "customers-table",
  addBtn: "add-customer-btn",
};

export const BOOKINGS = {
  container: "bookings-container",
  table: "bookings-table",
  addBtn: "add-booking-btn",
};

export const VISA = {
  container: "visa-container",
  table: "visa-table",
  addBtn: "add-visa-btn",
};

export const PAYMENTS = {
  container: "payments-container",
  table: "payments-table",
  addBtn: "add-payment-btn",
};

export const WHATSAPP = {
  container: "whatsapp-container",
  messageList: "whatsapp-messages",
  sendBtn: "whatsapp-send-btn",
};

export const REPORTS = {
  container: "reports-container",
  salesChart: "sales-chart",
  leadsChart: "leads-chart",
};

export const USERS = {
  container: "users-container",
  table: "users-table",
  addBtn: "add-user-btn",
};

export const ACCOUNTS = {
  container: "accounts-container",
  overviewTab: "accounts-overview-tab",
  incomeTab: "accounts-income-tab",
  expensesTab: "accounts-expenses-tab",
  ledgerTab: "accounts-ledger-tab",
  plTab: "accounts-pl-tab",
  addIncomeBtn: "add-income-btn",
  addExpenseBtn: "add-expense-btn",
  incomeTable: "income-table",
  expenseTable: "expense-table",
  ledgerTable: "ledger-table",
};
